import React, { useState } from 'react';
import { Button, Popover, DatePicker, Icon, Input, message } from 'antd';
import moment from 'moment';
import { getNextBusinessDay, isWeekend } from './helpers';

// Ensure Portuguese locale is set
moment.locale('pt-br');

const AddDate = ({
    cadenceData,
    setcadenceData,
    setActiveKey,
    groupedCadence,
}) => {
  const [inputDate, setInputDate] = useState('');
  const [inputType, setInputType] = useState('');
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleAddCadence = () => {
    const selectedDate = inputDate;
    const selectedType = inputType;

    const newCadence = {
      date: selectedDate,
      type: selectedType,
      status: 'pending',
    };

    const updatedCadenceData = [...cadenceData.data, newCadence];

    // Sort cadence by date asc
    updatedCadenceData.sort((a, b) => {
      return moment(a.date, 'DD/MM/YYYY').diff(moment(b.date, 'DD/MM/YYYY'));
    });

    setcadenceData({ ...cadenceData, data: updatedCadenceData });
    setActiveKey(selectedDate);
    setInputDate('');
    setInputType('');
    setPopoverVisible(false);
  };

  const handleDateChange = (date, dateString) => {
    const selectedDate = moment(dateString, 'DD/MM/YYYY');
    // Ensure the selected date is a business day
    const businessResult = getNextBusinessDay(selectedDate);
    
    if (businessResult.wasAdjusted) {
      message.info(
        `Data ajustada automaticamente: ${businessResult.originalDate.format('DD/MM/YYYY')} (${businessResult.originalDate.format('dddd')}) → ${businessResult.date.format('DD/MM/YYYY')} (${businessResult.date.format('dddd')})`,
        4
      );
    }
    
    setInputDate(businessResult.date.format('DD/MM/YYYY'));
  };

  const popoverContent = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <DatePicker
        placeholder="Selecione a data"
        format="DD/MM/YYYY"
        onChange={handleDateChange}
        disabledDate={(current) => {
          return current && isWeekend(current);
        }}
      />
      <Input
        placeholder="Defina a atividade"
        value={inputType}
        onChange={(e) => setInputType(e.target.value)}
      />
      <Button type="primary" size="small" onClick={handleAddCadence}>
        Salvar
      </Button>
    </div>
  );

  return (
    <div>
      <Popover
        content={popoverContent}
        title="Selecione a data e defina a atividade"
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={(visible) => setPopoverVisible(visible)}
      >
        <Button type="default" size="small" onClick={() => setPopoverVisible(true)}>
          <Icon type="plus" />
        </Button>
      </Popover>
    </div>
  );
};

export default AddDate;
